export default {
  home: {
    minute: "хвилина",
    price_info: "Безкоштовно за перші {mianfei} хв. Максимальна щоденна плата становить {currencyName}{fengding}. Депозит буде автоматично вираховано, коли орендна плата досягне {currencyName}{yajin}",
    feature_1: "Адаптований до всіх типів мобільних телефонів",
    feature_2: "Можна повернути на будь-який інший сайт",
    feature_3: "Спеціальний дизайн - бездротова зарядка (лише для підтримуваних модулів)",
    tips_1: "Ваш депозит {currencyName}{yajin} буде повернено вам після того, як ви повернете павербанк.",
    tips_2: "Депозит поповнення {currencyName}{yajin} можна взяти напрокат, використаний можна повернути",
    tips_3: "Поточний баланс становить {currencyName}{myyue}, який можна орендувати безпосередньо",
    submit: "Перезарядка",
    borrow: "Оренда",
    msg_fail_title: "Помилка",
    msg_fail_content: "Помилка прокату, повторіть спробу",
    msg_rentcount: "Зараз у вас є {zujieNum} замовлення, які не закрито",
    goborrow: "Ідіть на зарядку!!!",
    nearby: "Перегляньте торгові точки поблизу",
    preauth: "Попередня авторизація",
    nearbyvenues: "Lokalizacje w pobliżu"
  },
  login: {
    code_title: "SMS перевірка",
    phone_number: "Номер телефону",
    verification_code: "Будь ласка, введіть код підтвердження SMS. Якщо коду підтвердження немає, спробуйте інший спосіб входу.",
    captcha_code: "Код",
    send_code: "Надіслати код",
    login: "Логін",
    agree: "Натискаючи Увійти, ви погоджуєтесь ",
    readme: "Угода користувача",
    msg_fail_login: "Помилка входу",
    msg_success_login: "Вхід успішний",
    msg_fail_user: "Помилка отримання інформації про користувача. Хочеш спробувати ще раз?",
    sign_in_with: "Увійти за допомогою",
    no_sms: "Не отримав смс",
    retry: "Надіслати повторно",
    email: "E-Mail"
  },
  confirm: {
    deletecard: "Usuń kartę",
    addcard: "Wprowadź dane karty",
    title: "Підтвердження оплати",
    paynow: "Natychmiastowa płatność",
    SMSConfirm: "Будь ласка, сплатіть відповідно до текстового повідомлення, отриманого на ваш телефон, і натисніть кнопку підтвердження, щоб продовжити.",
    pay_label: "Сума",
    auth_label: "Попередня авторизація",
    price_tips: "Ваш баланс можна зняти за запитом. Може знадобитися 1-5 робочих днів, щоб з’явитися на вашому платіжному рахунку.",
    auth_tips: "Сума попередньої авторизації в розмірі {0}{1} є обов’язковою. Сума фактичної орендної плати буде вирахована під час повернення Powerbank.",
    pay_type: "Виберіть бажаний спосіб оплати",
    submit: "Підтвердити платіж",
    msg_loading: "Завантаження...",
    msg_fail_title: "УВАГА",
    msg_fail_payment: "Не вдалося ініціювати депозитний платіж",
    msg_fail_order: "Не вдалося створити замовлення на оренду",
    msg_fail_support: "Система не підтримується",
    msg_fail_confirm: "Підтвердити",
    msg_fail_retry: "Повторіть спробу",
    msg_fail_cancel: "Скасувати"
  },
  mine: {
    title: "Профіль користувача",
    wallet: "Мій гаманець",
    balance: "Мій баланс",
    deposit: "депозит",
    wallet_in: "Зарядити",
    wallet_out: "Вилучити",
    wallet_log: "Журнал гаманця",
    rental_history: "Historia wynajmu",
    payment_title: "Metody płatności",
    download_app: "Pobierz aplikację",
    settings: "Налаштування",
    help: "Довідка",
    logout: "Вийти",
    login_tips: "Будь ласка, увійдіть",
    msg_fail_title: "Помилка",
    msg_fail_update: "Не вдалося внести зміни, спробуйте ще раз",
    msg_loading: "Завантаження...",
    msg_fail_user: "Помилка отримання інформації про користувача. Хочеш спробувати ще раз?",
    edit_profile: "Edit Profile",
    join_us: "Dołącz do nas",
    join_us_details: "Zdobądź stację Blitz w swoim lokalu"
  },
  msg: {
    appoffline: "Aplikacja nie została jeszcze uruchomiona, proszę czekać",
    deletecard: "Ви впевнені, що хочете видалити цю картку?",
    no_phone: "Номер телефону обов'язковий",
    loading: "Завантаження...",
    title: "Підказка",
    success: "Успішна операція",
    error: "Невідома помилка, спробуйте пізніше.",
    roleerror: "Insufficient permissions. Please consult the administrator.",
    neterror: "Network connection failed. Please try again later",
    confirm: "Підтвердити",
    retry: "Повторіть спробу",
    cancel: "Скасувати",
    title_fail: "УВАГА",
    vieworder: "Переглянути замовлення",
    success_payment: "Оплату завершено",
    success_buy: "Купівля завершена",
    fail_payment: "Збій платежу",
    keyword: "ключове слово",
    ispayorder: "Proszę potwierdzić, czy płatność została dokonana",
    unpay: "Nie zapłacony",
    yespay: "Płatny",
    notopen: "Ще не відкрито"
  },
  result: {
    tips:
      "Aby wyświetlić zamówienia i inne lokalizacje stacji, pobierz aplikację.",
    download: "Pobierz aplikację",
    title: "Підтвердження результату",
    gotit: "Zrozumiałem",
    price_plan: "Стандарт заряду",
    msg_success: "Успішно здано в оренду",
    msg_tips_loading: "Портативна батарея вискакує, зачекайте терпляче...",
    msg_result_loading: "Результат оплати підтверджується...",
    msg_fail_confirm: "Підтвердити",
    btn_usage: "Примітка щодо використання",
    btn_return: "Зворотна записка",
    deposit: "депозит",
    msg_fail_content: "Помилка запиту, спробуйте ще раз",
    price_label: "за годину",
    price_info: "Безкоштовно за перші {mianfei} хв，Максимальна плата в розмірі {ccurrency}{fengding}，Депозит буде автоматично вираховано, коли орендна плата досягне {ccurrency}{yajin}",
    tips_1: "Будь ласка, візьміть павербанк No.{number}, як показано на малюнку",
    tips_2: "Будь ласка, приберіть кабелі та вставте зарядний пристрій донизу [стрілкою вниз], коли повернетеся",
    msg_note_usage: "Банк живлення оснащений 3 типами кабелів і бездротовою зміною, використовуйте за потреби.",
    msg_note_return: "Будь ласка, приберіть ці кабелі та вставте блок живлення в нижню частину [стрілкою вниз], коли повернетеся.",
    return_info: "Повернувшись, добре вставте кабелі та вставте сторону з металевою стружкою в порожню розетку, доки вона не досягне дна та не закріпиться.",
    download_tips: "Aby wypożyczyć nasz powerbank, możesz wybrać jedną z poniższych opcji"
  },
  result_msg: {
    loading: "Завантаження...",
    refresh: "Оновити"
  },
  order: {
    title: "Наказ про оренду",
    in_use: "У користуванні",
    ended: "Завершено",
    msg_error: "Запит не виконано",
    order_number: "немає",
    order_details: "Szczegóły zamówienia",
    order_zj_shop: "Miejsce wynajęte",
    order_zj_time: "Czas wynajmu",
    order_gh_shop: "Miejsce zwrócone",
    order_gh_time: "Czas powrócił",
    order_use_time: "Użyj czasu",
    order_amount: "Całkowita kwota",
    not_on_rent: "Nie na wynajem",
    "renting": "W umowie najmu",
    "undone": "Nie spełniony",
    "returned": "Zwrócony",
    "questions": "Pytania",
    "timeout_to_return": "Przekroczono limit czasu powrotu",
    "suspended_for_billing": "Zawieszono do rozliczenia"
  },
  order_item: {
    order_number: "немає",
    venue_rented: "Приміщення в оренді",
    time_rented: "Час в оренді",
    venue_returned: "Повернуто місце проведення",
    time_returned: "Час повернувся",
    charge_standard: "Стандарт заряду",
    charge_standard_info: "{pJifei} {pCurrency} на годину (перші {pMian} хв безкоштовно)",
    rent_occurred: "Сталася оренда",
    returned: "Повернувся",
    unreturned: "Неповернений",
    type_0: "Не завершено",
    type_1: "Оренда",
    type_2: "Скасовано",
    type_3: "Повернувся",
    type_4: "Сталася помилка",
    type_5: "Понаднормова робота",
    min: "Хв",
    payment: "Оплата",
    unpay: "nie płacić"
  },
  setting: {
    title: "Налаштування",
    lang: "Мова"
  },
  help: {
    title: "FAQ",
    rentals: "Wynajem",
    venues: "Miejsca",
    payments: "Płatności"
  },
  wallet_in: {
    title: "Поповнення балансу",
    price_label: "Сума поповнення",
    price_placeholder: "Будь ласка, введіть суму поповнення",
    balance: "Поточний баланс",
    price_auto: "Виберіть суму платежу",
    price_tips: "Ваш баланс можна зняти за запитом. Може знадобитися 1-5 робочих днів, щоб з’явитися на вашому платіжному рахунку.",
    submit: "Надіслати",
    loading: "Завантаження...",
    paying: "Перейдіть на сторінку оплати...",
    msg_title: "Поради",
    msg_fail_order: "Не вдалося створити замовлення на поповнення",
    msg_fail_payment: "Не вдалося розпочати платіж поповнення рахунку",
    msg_fail_retry: "Повторіть спробу"
  },
  wallet_out: {
    title: "Вилучення",
    price_label: "Сума зняття",
    price_placeholder: "Будь ласка, введіть суму зняття",
    balance: "Поточний баланс",
    balance_all: "Зняти все",
    deposit: "депозит",
    deposit_tips: "Є ордер на оренду. Депозит у розмірі {pcurrencyName}{pyajin} не повертається",
    submit: "Надіслати",
    apply: "Застосувати",
    confirm: "Підтвердити",
    loading: "Завантаження...",
    msg_fail_price: "Сума зняття невірна",
    msg_fail_balance: "Сума зняття не може перевищувати поточний баланс",
    msg_fail_submit: "Будь ласка, заповніть повну інформацію",
    msg_title: "Помилка",
    msg_success_content: "Застосувати повернення успішно",
    confirmtitle: "Поради",
    confirmcontent: "Поточний гаманець не підтримує зняття готівки. Будь ласка, запам’ятайте свою контактну інформацію та поверніть кошти вручну",
    payee_name: "Ім'я одержувача",
    payee_bankcard: "Номер банківської картки",
    payee_phone: "Телефон",
    cancelText: "скасувати",
    confirmText: "Повторно подайте заявку"
  },
  map: {
    在线: "Otwarte",
    离线: "Zamknąć",
    title: "Біля обладнання",
    result_msg: "Техніки поблизу виявлено не було",
    msg_title: "помилка",
    no_support: "вибачте! Ваш браузер не підтримує визначення місцезнаходження",
    my_position: "моє місцезнаходження",
    distance: "відстань:",
    shop_time: "години",
    free: "позичений",
    return: "повернення",
    shop_title: "Реквізити продавця",
    address: "адресу",
    go_here: "Іди сюди",
    nav_help: "Pomoc",
    nav_search: "Szukaj",
    locate: "Lokalizować"
  },
  scanQr: {
    NotAllowedError: 'Musisz przyznać dostęp do kamery',
    NotFoundError: 'Na tym urządzeniu nie ma aparatu',
    NotSupportedError: 'Wymagany kontekst bezpieczeństwa (HTTPS, localhost)',
    NotReadableError: 'Kamera jest w użyciu',
    OverconstrainedError: 'Instalacja kamery nie jest właściwa',
    StreamApiNotSupportedError: 'Ta przeglądarka nie obsługuje interfejsu API przesyłania strumieniowego'
  },
  payment: {
    payment_title: "Metody płatności",
    pay_type: "Proszę dodać dane swojej karty",
    add_payment_card: "Dodaj kartę płatniczą",
    add_payment: "dodaj płatność"
  },
  shop: {
    title: "Stacja w pobliżu",
    search_station: "Wyszukaj stację",
    search_station_tips: "Proszę wpisać nazwę stacji",
    shop_power_banks: "Banki mocy",
    shop_empty_slots: "Puste sloty",
    shop_address: "Adres",
    shop_business_hours: "Godziny otwarcia",
    shop_directions_station: "Uzyskaj wskazówki dojazdu do stacji",
    shop_scan_qrcode: "Zeskanuj kod QR"
  },
  time: {
    days: "днів",
    hours: "години",
    minutes: "хвилин"
  }
};
